<template>
  <v-container fluid class="pa-5">
    <v-row align="center" justify="center" wrap>
      <v-col cols="6">
        <v-text-field
          v-model="search"
          outlined
          solo
          class="rounded-lg"
          placeholder="search messages..."
          append-icon="search"
        />
      </v-col>
      <v-col
        xs="11"
        sm="11"
        md="7"
        lg="7"
        xl="7"
        v-for="message in messagesToDisplay"
        :key="message.id"
        class="my-2"
      >
        <v-card rounded="lg" class="mx-auto" outlined>
          <v-card-subtitle class="text-subtitle-1">
            <span class="primary--text font-weight-medium">{{
              message.name
            }}</span>
            {{ ' ' }}
            <span class="text-caption"
              >(<a
                class="font-italic text-caption"
                :href="`mailto:${message.email}`"
                >{{ message.email }}</a
              >)</span
            >
            ● {{ message.createdAt }}</v-card-subtitle
          >
          <v-card-text v-html="message.body" class="ma-2"></v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn icon @click="deleteMessage(message.id)">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="11"
        class="justify-center d-flex align-center"
        v-if="search && !messagesToDisplay.length"
      >
        <p class="text-center text-h5 primary--text font-weight-semibold">
          There is no related message regarding your search...
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatToElapsedTime } from '@/utils/date'

export default {
  name: 'ContactUs',
  async created() {
    if (!this.messages.length) {
      await this.$store.dispatch('contact_us/GET_ALL')
    }
  },
  data: () => ({
    search: ''
  }),
  computed: {
    messages() {
      const messages = this.$store.getters['contact_us/ALL']
      return messages.map((message) => ({
        id: message.id,
        name: message.name,
        email: message.email,
        createdAt: formatToElapsedTime(message.createdAt),
        body: message.body
      }))
    },
    messagesToDisplay() {
      const messages = [...this.messages]
      if (this.search) {
        const search = this.search.toLowerCase()
        return messages.filter(
          (message) =>
            message.name.toLowerCase().includes(search) ||
            message.email.toLowerCase().includes(search) ||
            message.body.toLowerCase().includes(search)
        )
      }

      return messages
    },
    user() {
      return this.$store.getters['users/AUTH_USER']
    }
  },
  methods: {
    async deleteMessage(id) {
      await this.$store.dispatch('contact_us/DELETE', { id })
    }
  }
}
</script>